import { db } from './index';
import { externalServices, users } from './schema';
import { eq } from 'drizzle-orm';

export async function listExternalServices(clerkId: string) {
  try {
    const user = await db.query.users.findFirst({
      where: eq(users.clerkId, clerkId)
    });

    if (!user) {
      return { success: false, error: 'User not found' };
    }

    const results = await db.query.externalServices.findMany({
      where: eq(externalServices.userId, user.id),
      orderBy: (externalServices, { desc }) => [desc(externalServices.createdAt)]
    });
    return { success: true, data: results };
  } catch (error) {
    console.error('Error listing external services:', error);
    return { success: false, error: 'Failed to list external services' };
  }
}

export async function listAllExternalServices() {
  try {
    const results = await db.query.externalServices.findMany({
      with: {
        user: true
      },
      orderBy: (externalServices, { desc }) => [desc(externalServices.createdAt)]
    });
    return { success: true, data: results };
  } catch (error) {
    console.error('Error listing all external services:', error);
    return { success: false, error: 'Failed to list all external services' };
  }
}

export async function createExternalService(clerkId: string, data: {
  name: string;
  type?: string;
  domain?: string;
  price: number;
  payType: 'ANUAL' | 'MENSUAL' | 'UNICO' | 'REFERIDO';
  startDate: Date;
  nextPaymentDate?: Date;
}) {
  try {
    const user = await db.query.users.findFirst({
      where: eq(users.clerkId, clerkId)
    });

    if (!user) {
      return { success: false, error: 'User not found' };
    }

    const result = await db.insert(externalServices).values({
      userId: user.id,
      name: data.name,
      type: data.type,
      domain: data.domain,
      price: data.price,
      payType: data.payType,
      startDate: data.startDate,
      nextPaymentDate: data.nextPaymentDate,
      currency: 'USD', // Default to USD as per schema default, but explicit here
    }).returning();

    return { success: true, data: result[0] };
  } catch (error) {
    console.error('Error creating external service:', error);
    return { success: false, error: 'Failed to create external service' };
  }
}

export async function deleteExternalService(id: string) {
  try {
    const result = await db.delete(externalServices).where(eq(externalServices.id, id)).returning();
    return { success: true, data: result[0] };
  } catch (error) {
    console.error('Error deleting external service:', error);
    return { success: false, error: 'Failed to delete external service' };
  }
}

export async function updateExternalService(id: string, data: Partial<typeof externalServices.$inferInsert>) {
  try {
    const result = await db.update(externalServices).set(data).where(eq(externalServices.id, id)).returning();
    return { success: true, data: result[0] };
  } catch (error) {
    console.error('Error updating external service:', error);
    return { success: false, error: 'Failed to update external service' };
  }
}
